module.exports = __webpack_public_path__ + "img/configuration.9e806097.png";